const serverCall ={
	// serverUrl:'http://localhost:3000',
	serverUrl:'https://globalbox.world:3000',
	// serverUrl:'http://localhost:3000',
    // serverUrl:'https://globalbox.world:3000',
	googleApiTranslation:'AIzaSyB5vqyOxPiTSNhHX6dZFLM3UgvcGR0PxAI',
	serverdomain:'globalbox.world',
	servername:'GlobalBox.world',
	appname:'GlobalBox',

} 
// const serverUrl = 'https://globalbox.world:3000';
// const googleApiTranslation = 'AIzaSyB5vqyOxPiTSNhHX6dZFLM3UgvcGR0PxAI';

export default serverCall